(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[161],{

/***/ 2538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories",
      function () {
        return __webpack_require__(978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ CategoryIconAndName; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/translations.tsx + 2 modules
var translations = __webpack_require__(171);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2692);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(964);
;// CONCATENATED MODULE: ./components/categoryIcon/MiddleIcons.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  vertical-align: text-top;\n  padding-right: 0.25em;\n  padding-top: 0.05em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var MiddleIcon = function(component) {
    return (0,styled_components_browser_esm/* default */.ZP)(component).withConfig({
        componentId: "sc-ef6042e8-0"
    })(_templateObject());
};
var GamingIcon = MiddleIcon(index_esm/* IoGameController */.Wjz);
var ProgrammingIcon = MiddleIcon(index_esm/* IoCodeSlash */.tqz);
var RamblingsIcon = MiddleIcon(index_esm/* IoChatbubbleEllipses */.jJE);
var MetaIcon = MiddleIcon(index_esm/* IoInformationCircle */.gOU);
/* harmony default export */ var MiddleIcons = ((/* unused pure expression or super */ null && (MiddleIcon)));

;// CONCATENATED MODULE: ./components/categoryIcon/CategoryIcon.tsx



var categoryNameIcon = {
    gaming: /*#__PURE__*/ (0,jsx_runtime.jsx)(GamingIcon, {}),
    development: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgrammingIcon, {}),
    ramblings: /*#__PURE__*/ (0,jsx_runtime.jsx)(RamblingsIcon, {}),
    meta: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaIcon, {})
};
function CategoryIcon(param) {
    var categoryName = param.categoryName;
    var CorrespondingCategoryIcon = categoryNameIcon[categoryName.toLowerCase()];
    if (CorrespondingCategoryIcon) {
        return CorrespondingCategoryIcon;
    }
    return null;
}
function CategoryIconAndName(param) {
    var categoryName = param.categoryName;
    var t = (0,translations/* useT */.N)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIcon, {
                categoryName: categoryName
            }),
            t.categories[categoryName]
        ]
    });
}


/***/ }),

/***/ 978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CategoriesPage; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(969);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(3641);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2893);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2267);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/react.mjs
var react = __webpack_require__(6945);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.mjs
var rich_text = __webpack_require__(4626);
// EXTERNAL MODULE: ./components/Box.tsx
var Box = __webpack_require__(4285);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2692);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(964);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(9384);
// EXTERNAL MODULE: ./components/categoryIcon/CategoryIcon.tsx + 1 modules
var CategoryIcon = __webpack_require__(4517);
;// CONCATENATED MODULE: ./components/Category.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: -10px var(--panel-padding-neg) 30px var(--panel-padding-neg);\n  padding: 10px var(--panel-padding) 10px var(--panel-padding);\n\n  &:target {\n    background-color: var(--highlight-color);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-42abeb17-0"
})(_templateObject());
function PostInCategory(param) {
    var node = param.node;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/post/".concat(node._sys.filename),
                children: node.title
            }),
            ",",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "entry-date",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                    dateTime: node.date,
                    itemProp: "datePublished",
                    children: (0,utils/* displayDate */.Po)(node.date, locale)
                })
            })
        ]
    });
}
function Category(param) {
    var categoryName = param.categoryName, posts = param.posts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
        id: categoryName.toLowerCase(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryIcon/* CategoryIconAndName */.e, {
                    categoryName: categoryName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: posts.map(function(post) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostInCategory, {
                        node: post
                    }, post.id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/layout/Layout.tsx + 3 modules
var Layout = __webpack_require__(7487);
// EXTERNAL MODULE: ./src/getUrls.ts
var getUrls = __webpack_require__(3916);
;// CONCATENATED MODULE: ./components/layout/head/getCategoriesPageJsonLd.ts

function getCategoriesPageJsonLd(param) {
    var locale = param.locale;
    return {
        "@type": "CollectionPage",
        "@id": "".concat((0,getUrls/* getBlogUrl */.Z)({
            locale: locale
        }), "/categories"),
        url: "".concat((0,getUrls/* getBlogUrl */.Z)({
            locale: locale
        }), "/categories")
    };
}

// EXTERNAL MODULE: ./src/getTranslatedPosts.ts
var getTranslatedPosts = __webpack_require__(9378);
;// CONCATENATED MODULE: ./pages/categories.tsx












/* eslint-enable prettier/prettier */ var description = "This page lists posts in each category.";
var __N_SSG = true;
function CategoriesPage(props) {
    var ref;
    // Pass our data through the "useTina" hook to make it editable
    var data = (0,react/* useTina */.UL)({
        query: props.query,
        variables: {},
        data: props.data
    }).data;
    var locale = (0,router.useRouter)().locale;
    var page = data.page.body;
    var enEdges = data.postConnection.edges;
    var frEdges = (ref = data.i18n_frConnection) === null || ref === void 0 ? void 0 : ref.edges;
    var translatedPosts = (0,getTranslatedPosts/* getTranslatedPosts */.I)(enEdges, frEdges, locale);
    var sortedPosts = (0,utils/* getSortedListablePosts */.of)(translatedPosts);
    var categories = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sortedPosts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var post = _step.value;
            var nodeCategories = post.categories;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = nodeCategories[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    var _category;
                    categories[category] = [
                        post
                    ].concat(_toConsumableArray((_category = categories[category]) !== null && _category !== void 0 ? _category : []));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        title: "Categories",
        description: description,
        jsonLd: getCategoriesPageJsonLd({
            locale: locale
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* BoxSection */.js, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text/* TinaMarkdown */.t, {
                        content: page
                    }),
                    Object.entries(categories).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], category = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                            categoryName: name,
                            posts: category
                        }, name);
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 9378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getTranslatedPosts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6701);

function getTranslatedPosts(edges, frEdges, locale) {
    var translatedPosts = edges.map(function(e) {
        return e.node;
    });
    if (locale === "fr") {
        // Get data, index it by filename
        var frPosts = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = frEdges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value.node;
                frPosts[node._sys.filename] = node;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Replace data
        translatedPosts = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = edges[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var post = _step1.value;
                var correspondingTranslation = frPosts[post.node._sys.filename];
                var frNode = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, post.node, correspondingTranslation);
                translatedPosts.push(frNode);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return translatedPosts;
}


/***/ }),

/***/ 3916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getBlogPostingUrl; },
/* harmony export */   "Z": function() { return /* binding */ getBlogUrl; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9384);

var getOriginWithLocale = function(locale) {
    return "".concat(_utils__WEBPACK_IMPORTED_MODULE_0__/* .ORIGIN */ .jQ).concat(locale === "fr" ? "/fr" : "");
};
var getBlogUrl = function(param) {
    var locale = param.locale;
    return getOriginWithLocale(locale);
};
var getBlogPostingUrl = function(param) {
    var locale = param.locale, slug = param.slug;
    return "".concat(getOriginWithLocale(locale), "/post/").concat(slug);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [260,94,644,487,774,888,179], function() { return __webpack_exec__(2538); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);